import styled, {useTheme} from 'styled-components/macro';

export const ColorBox = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 3px;
  display: inline-block;
  margin-right: 4px;
  flex-shrink: 0;
  background-color: ${props => props.color};
  ${props => props.theme.neumorphic && `
    width: 15px;
    height: 15px;
    box-shadow: inset 1px 1px 0 0 rgba(255, 255, 255, 0.3), inset -1px -1px 0 0 rgba(0, 0, 0, 0.3);
  `}
`;

/**
 * Converts hex color code to rbg values.
 * @param {String} hex
 * @return {{r: number, b: number, g: number}|null}
 */
export const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : null;
};

export const getBlackWhiteWithOpacity = (opacity, t) => {
  const theme = useTheme() || t;
  const rgb = hexToRgb(theme.dark ? '#FFFFFF' : '#000000');
  return `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity})`;
};

export const getHexWithOpacity = (hex, opacity) => {
  const rgb = hexToRgb(hex);
  return `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity})`;
};

export const getPositiveColor = t => {
  const theme = useTheme() || t;
  return theme.dark ? '#99FA66' : '#79AF30';
};

export const getNegativeColor = t => {
  const theme = useTheme() || t;
  return theme.dark ? '#FFCC03' : '#CF790B';
};

// export const COLOR_NEGATIVE_VALUE_RGB = 'rgb(255, 204, 3)';
// export const COLOR_POSITIVE_VALUE_RGB = 'rgb(160, 255, 107)';
export const COLOR_ZERO_VALUE = '#ffffff';
// export const COLOR_ZERO_VALUE_RGB = 'rgb(255, 255, 255)';
// export const COLOR_WARNING = 'rgb(255, 191, 0)';

export const getColorListPrimary = t => {
  const theme = t || useTheme();

  /* eslint-disable max-len */
  return [
    theme.dark ? '#99fa66' : '#118c4f',
    theme.dark ? '#ffcc03' : '#ff9900',
    '#22bec5',
    '#b3b4de',
    '#f77068',
    '#fdfb5a',
    '#ad24ad',
    '#fa66f9',
    '#7c3dc7',
    '#9e3c95',
    '#7d84c0',
    '#1a69d2',
    '#957e0b',
    '#782f00',
    '#f82912',
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
    15089250,
    7942239,
    1043613,
    10408947,
    13241773,
    3291935,
    16107942,
    8109387,
    54255,
    15823596,
    7444935,
    2589861,
    787321,
    5829059,
    16030522,
  ];
};

function zeroFill(number, width) {
  let w = width;
  w -= number.toString().length;
  if (w > 0) {
    return new Array(w + (/\./.test(number) ? 2 : 1)).join('0') + number;
  }
  return number + '';
}

export const getColor = colors => {
  const c = colors.shift();
  if (typeof c === 'string') {
    return c;
  }
  return '#' + zeroFill(c.toString(16), 6);
};
